var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.14,
    height: 247.17,
    viewBox: "0 0 222.14 247.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M6.99,78.2L0,5.75l42.84,30.93-15.17,16.88,24.1,16.56,36.15-16.16-13.94-17.97L111.07,0l37.09,35.99-13.94,17.97,36.15,16.16,24.1-16.56-15.17-16.88,42.84-30.93-6.99,72.45H6.99ZM8.26,91.26l2.33,24.11h77.16s-.02,83.41-.02,83.41h-37.53c-8.37,0-15.61-6.46-15.61-13.98s7.99-14.03,16.78-19.06l-38.49-26.67,7.09,73.45,91.11,34.65,91.11-34.65,7.09-73.45-38.49,26.67c8.79,5.03,16.78,11.54,16.78,19.06,0,7.52-7.24,13.97-15.61,13.98h-37.53s-.02-83.41-.02-83.41h77.16s2.33-24.11,2.33-24.11H8.26Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1b427c1ab9cbc8064be970d2a48e1ae4.svg";
export { ForwardRef as ReactComponent };